import { render, staticRenderFns } from "./reviewer-guidelines.vue?vue&type=template&id=21f9a84c&scoped=true&"
import script from "./reviewer-guidelines.vue?vue&type=script&lang=js&"
export * from "./reviewer-guidelines.vue?vue&type=script&lang=js&"
import style0 from "./reviewer-guidelines.vue?vue&type=style&index=0&id=21f9a84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f9a84c",
  null
  
)

export default component.exports